import React, { useState, useEffect } from 'react';
import API from '../api';
import { useNavigate, Link } from 'react-router-dom';
import toast from 'react-hot-toast';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [token, setToken] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const t = params.get('token');
    if (!t) navigate('/');
    setToken(t);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      toast.error('Passwords do not match!');
      return;
    }
    if (password.length < 6) {
      toast.error('Password must be at least 6 characters!');
      return;
    }
    try {
      await API.post('/auth/reset-password', { token, new_password: password });
      setSuccess(true);
      setTimeout(() => navigate('/'), 3000);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to reset password');
    }
  };

  if (success) {
    return (
      <div style={styles.container} className="container">
        <div style={styles.card}>
          <div style={{ fontSize: '48px', marginBottom: '1rem' }}>✅</div>
          <h2 style={styles.title}>Password Reset!</h2>
          <p style={styles.subtitle}>Your password has been reset successfully. Redirecting to login...</p>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container} className="container">
      <div style={styles.card}>
        <h2 style={styles.title}>Reset Password 🔑</h2>
        <p style={styles.subtitle}>Enter your new password below</p>
        <form onSubmit={handleSubmit}>
          <input style={styles.input} type="password" placeholder="New password (min 6 characters)" value={password} onChange={(e) => setPassword(e.target.value)} minLength={6} required />
          <input style={styles.input} type="password" placeholder="Confirm new password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
          <button style={styles.button} type="submit">Reset Password</button>
        </form>
        <p style={styles.link}><Link to="/">← Back to Login</Link></p>
      </div>
    </div>
  );
};

const styles = {
  container: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#f0f2f5' },
  card: { background: '#fff', padding: '2rem', borderRadius: '12px', width: '100%', maxWidth: '400px', boxShadow: '0 2px 12px rgba(0,0,0,0.1)', textAlign: 'center' },
  title: { fontSize: '22px', marginBottom: '0.5rem' },
  subtitle: { color: '#888', fontSize: '14px', marginBottom: '1.5rem' },
  input: { width: '100%', padding: '10px', marginBottom: '1rem', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box' },
  button: { width: '100%', padding: '10px', background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '16px', cursor: 'pointer' },
  link: { marginTop: '1rem', fontSize: '14px' },
};

export default ResetPassword;